var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z",
    fill: "#B2B7BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5C29.8366 5 37 12.1634 37 21C37 29.8366 29.8366 37 21 37C12.1634 37 5 29.8366 5 21C5 12.1634 12.1634 5 21 5ZM18.7481 14.4815H17.3259C16.7368 14.4815 16.2593 14.959 16.2593 15.5481V26.4519C16.2593 27.041 16.7368 27.5185 17.3259 27.5185H18.7481C19.3373 27.5185 19.8148 27.041 19.8148 26.4519V15.5481C19.8148 14.959 19.3373 14.4815 18.7481 14.4815ZM24.6741 14.4815H23.2519C22.6627 14.4815 22.1852 14.959 22.1852 15.5481V26.4519C22.1852 27.041 22.6627 27.5185 23.2519 27.5185H24.6741C25.2632 27.5185 25.7407 27.041 25.7407 26.4519V15.5481C25.7407 14.959 25.2632 14.4815 24.6741 14.4815Z",
    fill: "#D8DFE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMedal);
export default __webpack_public_path__ + "static/media/silver_medal.384eb6e09c8a2e0e2a8af2c3b7e00df1.svg";
export { ForwardRef as ReactComponent };